export default [

     {
          path: '/domain-control',
          name: 'DomainControl',   
          component: () => import("@/views/Page/DomainControl/Domain.vue"),
           meta: {
               title: "Domains",
          },
     }
];